export interface WeatherMessage {
  greeting: string;
  encouragement: string;
  rest: string;
}

export const weatherMessages: Record<string, WeatherMessage> = {
  sunny: {
    greeting: "今日はいい天気だね！でも無理しないでね",
    encouragement: "晴れの日も自分のペースでいいよ",
    rest: "天気がいいから散歩でもどう？"
  },
  cloudy: {
    greeting: "曇り空だけど、空ちゃんがいるよ",
    encouragement: "曇りの日はゆっくりでいいんだよ",
    rest: "曇り空を眺めながら休憩しよう"
  },
  rainy: {
    greeting: "雨の日はまったりしよう",
    encouragement: "雨音を聞きながらマイペースで",
    rest: "雨の音って落ち着くよね"
  },
  snowy: {
    greeting: "雪だ！暖かくして作業しよう",
    encouragement: "寒い日は温かい飲み物でも飲みながら",
    rest: "雪を見ながら温まろう"
  },
  thunder: {
    greeting: "雷が鳴ってるね、安全第一で",
    encouragement: "嵐の日は無理しちゃダメだよ",
    rest: "雷が収まるまで休憩しよう"
  },
  unknown: {
    greeting: "今日も空ちゃんと一緒だよ",
    encouragement: "マイペースでいこう",
    rest: "ゆっくり休憩しよう"
  }
};

export const getWeatherMessage = (
  condition: string, 
  type: keyof WeatherMessage = 'greeting'
): string => {
  return weatherMessages[condition]?.[type] || weatherMessages.unknown[type];
};